import { render, staticRenderFns } from "./Reinsurer.vue?vue&type=template&id=600e884c&scoped=true&"
import script from "./Reinsurer.vue?vue&type=script&lang=js&"
export * from "./Reinsurer.vue?vue&type=script&lang=js&"
import style0 from "./Reinsurer.vue?vue&type=style&index=0&id=600e884c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600e884c",
  null
  
)

export default component.exports